import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress';
import MaterialIcon from './../../components/MaterialIcon';
import Config from '../../constants/appConfig';
import Calls from '../../components/util/calls';
import saveAs from 'file-saver';
import { notification } from 'antd';

class KmzModal extends React.Component {
  baseState = {
    open: false,
    loading: false,
    job: null,
    exeItem: null,
    reportItem: null,
    task: null,
    title: '',
    idJob: null,
    guidLink: '',
    titulo: '',
    cliente: '',
    selectedProperty: '',
    customPropertyName: '',
    isCustomProperty: false,
    properties: [],
    areaTotalAplicada: '',
    inicioAplicacao: '',
    fimAplicacao: '',
    talhoes: [],
    checkTrajetoria: true,
    checkPoligono: true,
    checkPoligonoLimpo: false,
    checkXcl: true,
    checkVazao: true,
    checkVolume: true,
    checkOnOff: true,
    checkRumo: true,
    checkAltura: true,
    checkCliente: true,
    checkAeronave: true,
    checkClima: true,
    checkVelocidade: true,
    checkFaixa: true,
  };

  state = Object.assign({}, this.baseState);

  componentWillUnmount() {
    this.setState = () => {};
  }

  getFirstExecutionItem = (job) => {
    if (!job || !job.list_exe || !job.list_exe.length) return null;

    return job.list_exe.filter(function (item) {
      return item && item.guid && item.progress_task === 100;
    })[0] || job.list_exe.filter(function (item) {
      return item && item.guid;
    })[0] || job.list_exe[0];
  };


  getReportItem = (job) => {
    if (!job || !job.list_rel || !job.list_rel.length) return null;

    return job.list_rel.filter(function (item) {
      return item && item.guid && item.progress_task === 100;
    })[0] || job.list_rel.filter(function (item) {
      return item && item.guid;
    })[0] || job.list_rel[0];
  };

  open = (job) => {
    const exeItem = this.getFirstExecutionItem(job);
    const reportItem = this.getReportItem(job);

    if (!job || !reportItem || !reportItem.guid) {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    this.setState(Object.assign({}, this.baseState, {
      open: true,
      loading: true,
      job: job,
      exeItem: exeItem,
      reportItem: reportItem,
      title: exeItem && exeItem.title ? exeItem.title : job.title,
      guidLink: reportItem.guid
    }), () => {
      this.loadTask(job, exeItem, reportItem);
    });
  };

  close = () => {
    if (this.state.loading) return;
    this.setState({ open: false });
  };

  loadTask = (job, exeItem, reportItem) => {
    const apiUrl = Config.server + '/job_check/importzjob/' + reportItem.guid;
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        let taskId = null;
        if (result && result.data && result.data.task) taskId = result.data.task;
        if (!taskId && result && result.task && result.task.id) taskId = result.task.id;
        if (!taskId && reportItem.id_task) taskId = reportItem.id_task;
        if (!taskId && reportItem.task) taskId = reportItem.task;
        if (!taskId && exeItem && exeItem.id_task) taskId = exeItem.id_task;
        if (!taskId && exeItem && exeItem.task) taskId = exeItem.task;

        if (taskId) {
          this.setState({ task: taskId }, () => this.loadGetResultTitle(taskId, job, exeItem));
        } else {
          this.setState({ loading: false });
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      })
      .catch((error) => this.handleError(error));
  };

  loadGetResultTitle = (taskId, job, exeItem) => {
    const apiUrl = Config.server + '/getResult/' + taskId;
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    fetch(apiUrl, options)
      .then((response) => {
        if (response.status !== 200) throw response;
        return Calls.toJSON(response.headers.get('content-length'), response.body, () => {});
      })
      .then((result) => {
        if (!result || result === 'file not found.') {
          this.setState({ title: job.title, loading: false });
          return;
        }

        const data = typeof result === 'string' ? JSON.parse(result) : result;
        this.applyResultData(data, job, exeItem, taskId);
      })
      .catch(() => {
        this.setState({ title: job.title, loading: false });
      });
  };

  applyResultData = (data, job, exeItem, taskId) => {
    const polygons = data && data.polygons && Array.isArray(data.polygons) ? data.polygons : [];
    const idClient = data && data.id_client ? data.id_client : job && job.id_client ? job.id_client : null;

    const talhoes = polygons.map((polygon) => {
      const coordinates = polygon && polygon.poly && polygon.poly.geometry && polygon.poly.geometry.coordinates && polygon.poly.geometry.coordinates[0]
        ? polygon.poly.geometry.coordinates[0]
        : [];
      const firstCoordinate = coordinates && coordinates.length ? coordinates[0] : [];

      return {
        name: polygon && polygon.name ? polygon.name : '',
        latitude: firstCoordinate && firstCoordinate.length > 1 ? firstCoordinate[1] : '',
        longitude: firstCoordinate && firstCoordinate.length > 0 ? firstCoordinate[0] : ''
      };
    });

    const title = data && data.title ? data.title : job && job.title ? job.title : '';
    const client = data && data.customerName ? data.customerName :
      data && data.customername ? data.customername : '';
    const area = data && data.apl && data.apl.area_aplicada ? data.apl.area_aplicada : '';

    this.setState({
      idJob: job && job.id ? job.id : null,
      task: taskId,
      title: title,
      titulo: title,
      cliente: client,
      selectedProperty: this.getPropertyName(data, job),
      areaTotalAplicada: area,
      inicioAplicacao: this.getStartDate(data, exeItem, polygons),
      fimAplicacao: this.getEndDate(data, exeItem, polygons),
      talhoes: talhoes,
      loading: false
    }, () => {
      if (idClient) this.listProperties(idClient);
    });
  };

  getPropertyName = (data, job) => {
    if (data && data.property) return data.property;
    if (data && data.service_order && data.service_order.property) return data.service_order.property;
    if (job && job.list_os && job.list_os.length > 0 && job.list_os[0].serviceOrder && job.list_os[0].serviceOrder.property) {
      return job.list_os[0].serviceOrder.property;
    }
    return '';
  };

  getStartDate = (data, exeItem, polygons) => {
    if (exeItem && exeItem.startDate) return this.toInputDateTime(exeItem.startDate);
    if (data && data.startDate) return this.toInputDateTime(data.startDate);
    if (polygons && polygons.length && polygons[0].startDate) return this.toInputDateTime(polygons[0].startDate);
    return '';
  };

  getEndDate = (data, exeItem, polygons) => {
    if (exeItem && exeItem.endDate) return this.toInputDateTime(exeItem.endDate);
    if (data && data.endDate) return this.toInputDateTime(data.endDate);
    if (polygons && polygons.length && polygons[0].endDate) return this.toInputDateTime(polygons[0].endDate);
    return '';
  };

  toInputDateTime = (value) => {
    if (!value) return '';
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return '';
    const pad = (num) => String(num).padStart(2, '0');
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + 'T' + pad(date.getHours()) + ':' + pad(date.getMinutes());
  };

  listProperties = (idClient) => {
    if (!idClient) return;

    const apiUrl = Config.server + '/allProperty/' + idClient;
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        this.setState({ properties: Array.isArray(result) ? result : [] });
      })
      .catch((error) => this.handleError(error, true));
  };

  download = () => {
    if (!this.state.task) return;

    this.setState({ loading: true });

    const data = {
      culture: this.props.res.LINGUA,
      id: this.state.task,
      guid_link: this.state.guidLink,
      id_job: this.state.idJob,
      titulo: this.state.titulo,
      cliente: this.state.cliente,
      property: this.state.selectedProperty,
      otherProperty: this.state.customPropertyName,
      areaTotalAplicada: this.state.areaTotalAplicada,
      inicioAplicacao: this.state.inicioAplicacao,
      fimAplicacao: this.state.fimAplicacao,
      talhoes: this.state.talhoes,
      config: {
        checkVazao: this.state.checkVazao,
        checkVolume: this.state.checkVolume,
        checkAltura: this.state.checkAltura,
        checkCliente: this.state.checkCliente,
        checkAeronave: this.state.checkAeronave,
        checkClima: this.state.checkClima,
        checkPoligono: this.state.checkPoligono,
        checkPoligonoLimpo: this.state.checkPoligonoLimpo,
        checkVelocidade: this.state.checkVelocidade,
        checkFaixa: this.state.checkFaixa,
        checkOnOff: this.state.checkOnOff,
        checkRumo: this.state.checkRumo,
        checkTrajetoria: this.state.checkTrajetoria
      }
    };

    const options = {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(Config.server + '/relkmz', options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.blob();
      })
      .then((result) => {
        this.setState({ loading: false, open: false });
        saveAs(result, this.getFileName() + '.kmz');
      })
      .catch((error) => this.handleError(error));
  };

  getFileName = () => {
    return String(this.state.title).replace(/[\\/:.!]/g, '-');
  };

  handleError = (error) => {
    this.setState({ loading: false });
    if (error && (error.status === 401 || error.status === 403)) {
      this.props.link('/login');
      return;
    }
    notification.open({
      message: this.props.res.ERRO,
      description: this.props.res.ERRO_MSG,
      icon: <MaterialIcon icon="error" className="text-danger" />
    });
  };

  toggle = name => () => {
    this.setState({ [name]: !this.state[name] });
  };


  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  renderTextField = (name, label, props) => {
    return (
      <TextField
        label={label}
        fullWidth
        value={this.state[name]}
        onChange={this.handleChange(name)}
        margin="dense"
        {...props}
      />
    );
  };

  renderPropertyField = () => {
    const { res } = this.props;
    return (
      <div style={{ display: 'grid', gridTemplateColumns: this.state.isCustomProperty ? '1fr 1fr' : '1fr', gap: '1rem' }}>
        <FormControl fullWidth margin="dense">
          <InputLabel htmlFor="select-property-kmz">{res.PROPRIEDADE}</InputLabel>
          <Select
            id="select-property-kmz"
            value={this.state.isCustomProperty ? 'other-property' : this.state.selectedProperty}
            onChange={(event) => {
              const value = event.target.value;
              this.setState({
                selectedProperty: value === 'other-property' ? '' : value,
                isCustomProperty: value === 'other-property'
              });
            }}
          >
            <MenuItem key="0property" value="" disabled>{res.SELECIONE_PROPRIEDADE}</MenuItem>
            {this.state.properties.map((item, index) => (
              <MenuItem key={index} value={item.name}>{item.name}</MenuItem>
            ))}
            <MenuItem key="other-property" value="other-property">{res.OUTROTXT}</MenuItem>
          </Select>
        </FormControl>
        {this.state.isCustomProperty && this.renderTextField('customPropertyName', res.NOME_PROPRIEDADE)}
      </div>
    );
  };

  renderSwitch = (name, label) => {
    return <FormControlLabel control={<Switch color="primary" checked={this.state[name]} name={name} onClick={this.toggle(name)} />} label={label} />;
  };

  render() {
    const { res } = this.props;

    return (
      <Dialog open={this.state.open} onClose={this.close} maxWidth="sm" fullWidth PaperProps={{ style: { backgroundColor: 'white', maxWidth: '44rem' } }}>
        <DialogTitle style={{ backgroundColor: 'white' }}>{res.CONFIGURACOES_RELATORIO}</DialogTitle>
        <DialogContent style={{ backgroundColor: 'white' }}>
          {this.state.loading ?
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <CircularProgress />
              <div style={{ marginTop: '1rem' }}>{res.PROCESSANDO}</div>
            </div>
            :
            <div>
              <h3>{res.RELATORIO}</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '1.5rem', rowGap: '.5rem' }}>
                {this.renderTextField('titulo', res.TITULO)}
                {this.renderTextField('cliente', res.CLIENTE)}
                {this.renderPropertyField()}
                {this.renderTextField('areaTotalAplicada', res.AREA_TOTAL_APLICADA)}
                {this.renderTextField('inicioAplicacao', res.INICIO_APLICACAO, { type: 'datetime-local', InputLabelProps: { shrink: true } })}
                {this.renderTextField('fimAplicacao', res.FIM_APLICACAO, { type: 'datetime-local', InputLabelProps: { shrink: true } })}
              </div>

              {this.state.talhoes.length > 0 &&
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
                  {this.state.talhoes.map((talhao, index) => (
                    <React.Fragment key={index}>
                      <TextField label={res.TALHAO + ' ' + (index + 1)} fullWidth value={talhao.name} onChange={(e) => {
                        const talhoes = this.state.talhoes.slice();
                        talhoes[index].name = e.target.value;
                        this.setState({ talhoes: talhoes });
                      }} />
                      <TextField label={res.LATITUDE} fullWidth value={talhao.latitude} onChange={(e) => {
                        const talhoes = this.state.talhoes.slice();
                        talhoes[index].latitude = e.target.value;
                        this.setState({ talhoes: talhoes });
                      }} />
                      <TextField label={res.LONGITUDE} fullWidth value={talhao.longitude} onChange={(e) => {
                        const talhoes = this.state.talhoes.slice();
                        talhoes[index].longitude = e.target.value;
                        this.setState({ talhoes: talhoes });
                      }} />
                    </React.Fragment>
                  ))}
                </div>
              }

              <h3>{res.MAPA}</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '1.5rem' }}>
                {this.renderSwitch('checkTrajetoria', res.TRAJETORIA_VOO)}
                {this.renderSwitch('checkPoligono', res.POLIGONO_APLICADO)}
                {this.renderSwitch('checkPoligonoLimpo', res.POLIGONO_NAO_APLICADO)}
                {this.renderSwitch('checkXcl', res.ZONA_EXCLUSAO)}
              </div>

              <h3>{res.TRABALHO}</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '1.5rem' }}>
                {this.renderSwitch('checkVazao', res.VAZAO)}
                {this.renderSwitch('checkVolume', res.VOLUME_APLICADO)}
                {this.renderSwitch('checkOnOff', res.SPRAY_ON_OFF)}
                {this.renderSwitch('checkRumo', res.RUMO_AB)}
                {this.renderSwitch('checkAltura', res.ALTURA)}
                {this.renderSwitch('checkCliente', res.NOME_CLIENTE)}
                {this.renderSwitch('checkAeronave', res.PREFIXO_AERONAVE)}
                {this.renderSwitch('checkClima', res.VARIAVEIS_CLIMA)}
                {this.renderSwitch('checkVelocidade', res.VELOCIDADE)}
                {this.renderSwitch('checkFaixa', res.FAIXA_APLICACAO)}
              </div>
            </div>
          }
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'space-evenly', backgroundColor: 'white' }}>
          <Button disabled={this.state.loading} component="span" variant="contained" color="primary" className="popUpButton" title={res.PROCESSAR_JOB} onClick={this.download}>
            <MaterialIcon icon="file_download" />
          </Button>
          <Button disabled={this.state.loading} variant="contained" onClick={this.close} className="popUpButton">
            {res.CANCELAR}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default KmzModal;
